import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-[var(--mx-line)] bg-[var(--mx-bg)]"
  >
    <a
      href="#quote"
      data-cursor="view"
      className="group block border-b border-[var(--mx-line)] py-16 md:py-24"
    >
      <Marquee speed={60} gradient={false} autoFill>
        <span className="mx-8 font-display text-6xl font-black uppercase tracking-tighter text-[var(--mx-ink)] transition-colors duration-300 group-hover:text-[var(--mx-copper)] md:text-8xl">
          Let&apos;s talk
        </span>
        <span className="text-stroke-accent mx-8 font-display text-6xl font-black uppercase tracking-tighter md:text-8xl">
          Let&apos;s talk
        </span>
      </Marquee>
    </a>

    <div className="mx-auto grid max-w-[1400px] gap-10 px-6 py-16 md:grid-cols-4 md:px-10">
      <div>
        <div className="flex items-center gap-3">
          <img
            src="/metalix-mark.png"
            alt="Metalix logo"
            className="h-16 w-auto object-contain"
          />
          <span className="flex flex-col leading-none">
            <span className="font-display text-3xl font-extrabold uppercase tracking-tight text-[var(--mx-ink)]">
              Metalix XT
            </span>
            <span className="mt-1 flex w-full justify-between font-mono-tech text-[10px] uppercase text-[var(--mx-ink-2)]">
              {"Private Limited".split("").map((c, i) => (
                <span key={i}>{c === " " ? "\u00A0" : c}</span>
              ))}
            </span>
          </span>
        </div>
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-[var(--mx-ink-2)]">
          Metalix XT Pvt Ltd — manufacturer of high-purity refined lead and lead
          alloys from recycled sources.
        </p>
      </div>

      <div>
        <h4 className="font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink-2)]">
          Contact
        </h4>
        <a
          href="mailto:Info@Metalix-XT.com"
          className="mt-4 block text-sm text-[var(--mx-ink)] transition-colors hover:text-[var(--mx-copper)]"
        >
          Info@Metalix-XT.com
        </a>
        <a
          href="mailto:Info@MetalixRecycle.com"
          className="mt-1 block text-sm text-[var(--mx-ink)] transition-colors hover:text-[var(--mx-copper)]"
        >
          Info@MetalixRecycle.com
        </a>
        <a
          href="tel:+919871737737"
          className="mt-2 block text-sm text-[var(--mx-ink)] transition-colors hover:text-[var(--mx-copper)]"
        >
          +91 98717 37737
        </a>
      </div>

      <div>
        <h4 className="font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink-2)]">
          Corporate Office
        </h4>
        <p className="mt-4 text-sm leading-relaxed text-[var(--mx-ink-2)]">
          6th Floor, B Block, 50 Chowringhee Road,
          <br />
          Kolkata, West Bengal — 700071
        </p>
      </div>

      <div>
        <h4 className="font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink-2)]">
          Plant
        </h4>
        <p className="mt-4 text-sm leading-relaxed text-[var(--mx-ink-2)]">
          R.S. No. 21, Village Sardarapura,
          <br />
          Jambusar, District Bharuch,
          <br />
          Gujarat — 392150
        </p>
      </div>
    </div>

    <div className="mx-auto flex max-w-[1400px] flex-col gap-2 border-t border-[var(--mx-line)] px-6 py-8 font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink-3)] md:flex-row md:items-center md:justify-between md:px-10">
      <span>© {new Date().getFullYear()} Metalix XT Pvt Ltd</span>
      <div className="flex flex-wrap items-center gap-4">
        <span>Refined Lead · Lead Alloys · Pb 99.97%+</span>
        <span className="text-[var(--mx-line-strong)]">·</span>
        <Link
          to="/e-waste-recycling"
          data-testid="footer-ewaste-link"
          className="text-[var(--mx-ink-3)] underline-offset-4 transition-colors hover:text-[var(--mx-copper)] hover:underline"
        >
          E-Waste
        </Link>
        <Link
          to="/minor-metals"
          data-testid="footer-minor-metals-link"
          className="text-[var(--mx-ink-3)] underline-offset-4 transition-colors hover:text-[var(--mx-copper)] hover:underline"
        >
          Minor Metals
        </Link>
        <Link
          to="/cards"
          data-testid="footer-cards-link"
          className="text-[var(--mx-ink-3)] underline-offset-4 transition-colors hover:text-[var(--mx-copper)] hover:underline"
        >
          Business Cards
        </Link>
        <Link
          to="/admin"
          data-testid="footer-admin-link"
          className="text-[var(--mx-ink-3)] underline-offset-4 transition-colors hover:text-[var(--mx-copper)] hover:underline"
        >
          Admin
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
